// extracted by mini-css-extract-plugin
export var form = "_dg-0";